import React from 'react';

import { ButtonAria } from './ButtonAria';
import { ILinkButtonProps, LinkButtonAria } from './LinkButtonAria';
import { AriaButtonProps } from '@react-aria/button';

export type IPolymorphicBaseButtonProps = AriaButtonProps<'button'> & ILinkButtonProps;

// I'm not thrilled about this "any" but I'm not sure what the actual type is.
export const PolymorphicBaseButton = React.forwardRef<HTMLAnchorElement | HTMLButtonElement | any>((props: IPolymorphicBaseButtonProps, ref) => {
  const ButtonComponent = props.to ? LinkButtonAria : ButtonAria;

  return (
    <ButtonComponent
      {...props}
      ref={ref}
    />
  );
});
